import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/auth/AuthContext";
import { Logo } from "@/components/Logo";
import { Loader2 } from "lucide-react";

export function Splash() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-7 bg-black">
      <Logo size={48} tone="mono" />
      <Loader2 className="h-6 w-6 animate-spin text-rig-accent" />
    </div>
  );
}

export default function ProtectedRoute() {
  const { user, loading } = useAuth();
  if (loading) return <Splash />;
  if (!user) return <Navigate to="/login" replace />;
  return <Outlet />;
}
